import { Routes, Route } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './lib/auth.tsx';
import { Landing } from './routes/landing.tsx';
import { Login } from './routes/login.tsx';
import { Shell } from './components/Shell.tsx';
import { Jobs } from './routes/jobs.tsx';
import { JobNew } from './routes/job-new.tsx';
import { JobDetail } from './routes/job-detail.tsx';
import { Review } from './routes/review.tsx';
import { TakeoffRebar } from './routes/takeoff-rebar.tsx';
import { TakeoffCivil } from './routes/takeoff-civil.tsx';
import { Output } from './routes/output.tsx';
import { Training } from './routes/training.tsx';

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/app"
          element={
            <RequireAuth>
              <Shell />
            </RequireAuth>
          }
        >
          <Route index element={<Jobs />} />
          <Route path="jobs" element={<Jobs />} />
          <Route path="jobs/new" element={<JobNew />} />
          <Route path="jobs/:id" element={<JobDetail />} />
          <Route path="jobs/:id/review" element={<Review />} />
          <Route path="jobs/:id/takeoff/rebar" element={<TakeoffRebar />} />
          <Route path="takeoff/rebar" element={<TakeoffRebar />} />
          <Route path="jobs/:id/takeoff/civil" element={<TakeoffCivil />} />
          <Route path="takeoff/civil" element={<TakeoffCivil />} />
          <Route path="output" element={<Output />} />
          <Route path="jobs/:id/output" element={<Output />} />
          <Route path="training" element={<Training />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
